import React from 'react'
import PropTypes from 'prop-types'

import styled, { themeGet, themePx } from 'util/style'

import { Box } from 'components/Grid'
import { Container } from 'components/Grid'

const StyledFooter = styled(Box)`
  display: block;
  background: rgb(235, 217, 208);
  width: 100%;
  padding: 60px 0;
  margin-top: 60px;
  font-size: 13px;
  color: #000;
`

const Wrapper = styled.div`
  display: flex;

  @media (max-width: 640px) {
    display: block;
  }
`

const Title = styled.h1`
  margin: 0 auto 40px auto;
  display: block;
  font-family: 'Slowly-Two', sans-serif !important;
  text-align: center;
  color: #333;
  font-size: 120px;
  font-weight: normal;
  text-decoration: none;
`

const Footer = ({ children, ...props }) => (
  <StyledFooter as="footer" {...props}>
    <Title>Gutsy</Title>

    <Container maxWidth={'1040px'}>
      <Wrapper>{children}</Wrapper>
    </Container>
  </StyledFooter>
)

Footer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default Footer
